import React, { Component } from 'react';
import { isArray } from 'lodash';
import {
    FormControl,
    Select as MuiSelect,
    MenuItem,
    Checkbox,
    ListItemText,
} from '@mui/material';
import { getActiveDictOptions } from '../../agenda/Cro/CroActions';

export default class MultiSelect extends Component {
    state = { options: [] };

    async componentDidMount() {
        const { url, dispatch } = this.props;
        const options = await getActiveDictOptions(url, dispatch);
        this.setState({ options });
    }

    render() {
        const { input, disabled } = this.props;
        const opts = this.state.options;
        const value = isArray(input.value) ? input.value : [];
        const selectedIds = value.map((v) => v && v.id).filter(Boolean);
        return (
            <FormControl variant="outlined" size="small" fullWidth disabled={disabled}>
                <MuiSelect
                    multiple
                    displayEmpty
                    value={selectedIds}
                    onChange={(e) => {
                        const ids = e.target.value;
                        input.onChange(opts.filter((o) => ids.includes(o.id)));
                    }}
                    onBlur={() => input.onBlur(value)}
                    renderValue={(selected) =>
                        opts
                            .filter((o) => selected.includes(o.id))
                            .map((o) => o.name)
                            .join(', ')
                    }
                    MenuProps={{ disablePortal: true, disableScrollLock: true }}
                >
                    {opts.map((o) => (
                        <MenuItem key={o.id} value={o.id}>
                            <Checkbox checked={selectedIds.includes(o.id)} />
                            <ListItemText primary={o.name} />
                        </MenuItem>
                    ))}
                </MuiSelect>
            </FormControl>
        );
    }
}
